<template>
    <BaseModal size="small" status="error">
        <div class="flex justify-center flex-col items-center">
            <i class="fa-regular fa-circle-check text-vw-red text-4xl mb-4"></i>
            <h3 class="text-xl text-vw-red mb-2 futura-bold">{{ $t('Geannuleerd') }}</h3>
            <p class="my-2 text-vw-gray">{{ $t('De depot uitbreiding is geannuleerd.')}}</p>
        </div>
    </BaseModal>
</template>

<script>
import BaseModal from "./BaseModal.vue";

export default {
    name: 'ExtendDepotRefuse',
    components: { BaseModal },
}
</script>
